<template>
  <ReportWrapper :is-downloading="isLoading" @download="downloadPdf" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'IpiAgingReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const { useDownloadIpiAgingReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadIpiAgingReport();

    const downloadPdf = async () => {
      try {
        const response = await downloadReport();

        if (!response?.data) {
          console.error('No data received from the server');
          return;
        }

        const { base64Data, filename } = response.data;

        if (!base64Data) {
          console.error('No base64 data in response');
          return;
        }

        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = filename || `IPI Aging Report ${date(new Date())}.xlsx`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error('Error downloading report:', e);
      }
    };

    return { downloadPdf, isLoading };
  },
});
</script>
